/**
 * When we are inside of a Shadow DOM, we need to manually set the root element of all floating elements.
 * This is required to properly style and position those elements.
 */
export function getFloatingPortalRoot() {
  if (typeof window === 'undefined') {
    return;
  }
  return document.getElementById('tmh-website-header')?.shadowRoot?.getElementById('render-root') as
    | HTMLElement
    | undefined;
}

/**
 * The trust badge overlays the floating UI on mobile device and in some desktop views.
 * This function hides or shows the trust badge depending on the isOpen parameter.
 */
export function toggleTrustBadge(show: boolean) {
  const trustbadge = document.querySelector<HTMLDivElement>('[id^="trustbadge-container-"]');
  if (!trustbadge) {
    return;
  }
  trustbadge.style.zIndex = show ? '2147483647' : '299';
  trustbadge.style.transition = 'opacity 0.5s ease';
  trustbadge.style.opacity = show ? '1' : '0';
}
